import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import { FormField } from 'global/components/Form'
import { SelectEmpresa } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { afd } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { z } from 'zod'

type FormData = {
    dataInicial: string
    dataFinal: string
    empresaId: number
}

export const GerarAfdModal = () => {
    const empresaId = useStore(state => state.companyId)
    const empresa = useStore(state => state.company)
    const navigate = useNavigate()

    const { mutate } = afd.mutations.useCreate({
        invalidateQuery: true,
        queryParams: {
            empresaId,
        },
    })

    const handleSubmit: SubmitHandler<FormData> = ({
        dataInicial,
        dataFinal,
    }) => {
        if (!empresa?.cpfResponsavel) {
            toast.error(
                'Não é possível gerar AFD sem responsável técnico, termine o cadastro da empresa',
            )
            return navigate(-1)
        }

        mutate(
            {
                empresaId,
                dataInicial,
                dataFinal,
            } as any,
            {
                onSuccess: async ({ filename }: any) => {
                    toast.success('Arquivo gerado com sucesso!')

                    await afd.download(filename as string)

                    navigate(-1)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['create', 'AFD'])}
            width="34rem"
            height="auto"
            onSubmit={handleSubmit}
            schema={z.object({
                dataInicial: z.string().min(1, 'Campo obrigatório'),
                dataFinal: z.string().min(1, 'Campo obrigatório'),
            })}
            defaultValues={{
                dataInicial: dayjs().startOf('month').format('YYYY-MM-DD'),
                dataFinal: dayjs().endOf('month').format('YYYY-MM-DD'),
            }}
        >
            <Dialog.Title>Gerar AFD</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container columnSpacing={2} alignItems="center">
                    <Grid item xs={12}>
                        <SelectEmpresa width="100%" size="medium" />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography mb={1.5} mt={3} className="select-none">
                            Período de exportação dos registros
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="dataInicial"
                            label="Data inicial"
                            type="date"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="dataFinal"
                            label="Data final"
                            type="date"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>
                    Exportar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
